<template>
  <CRow>
    <CCol col="12">
      <CCard>
        <loader v-show="loading"/>
        <CCardHeader> <CIcon name="cil-grid" />User List
          <div class="card-header-actions">
            <CLink href="#" class="card-header-action btn-setting">
              <a @click="addUser">
                <CIcon name="cil-plus" />
              </a>
            </CLink>
          </div>
        </CCardHeader>
        <CCardBody>
          <table class="table table-bordered table-striped">
            <thead>
              <tr>
                <th>No</th>
                <th>Name</th>
                <th>Phone</th>
                <th>Email</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(v, k) in data" :key="k">
                <td>
                  <table-number
                    :index="k"
                    :page="paginate.page"
                    :size="paginate.size"
                  />
                </td>
                <td>{{ v.name }} <span class="badge badge-danger" v-show="v.data_deleted_at">Deleted</span></td>
                <td>{{ v.phone }}</td>
                <td>{{ v.email.email }}</td>
                <td>
                  <btn-edit @click="doEdit(v.id)"/>
                  <btn-delete @click="doDelete(v.id)"/>
                </td>
              </tr>
            </tbody>
          </table>
        </CCardBody>
        <CCardFooter>
          <content-pagination
            :page="paginate.page"
            :size="paginate.size"
            :total="paginate.total"
            @input="changePage"
          />
        </CCardFooter>
      </CCard>
    </CCol>
  </CRow>
</template>
<script>
import { HTTPAUTH } from "../../lib/httplib";
import TableNumber from "../../components/TableNumber";
import ContentPagination from "../../components/ContentPagination";
import BtnEdit from "../../components/BtnEdit"
import BtnDelete from "../../components/BtnDelete"
import Loader from '../../components/Loader.vue';
import { showErrorMessage } from '../../lib/helpers';
export default {
  components: {
    TableNumber,
    ContentPagination,
    BtnEdit,
    BtnDelete,
    Loader,
  },
  data() {
    return {
      data: {},
      paginate: {},
      loading: true
    };
  },
  created() {
    this.getList(1);
  },
  methods: {
    getList(page) {
      this.loading = true;
      HTTPAUTH.get(`/api/v1/admin/user?page=${page}&size=10`).then((res) => {
        this.loading = false;
        this.data = res.data.data;
        this.paginate = res.data.paginate;
      }).catch(() => {
        this.loading = false;
      });
    },
    changePage(p) {
      this.getList(p);
    },
    addUser() {
      this.$router.push({path: "/user/add"})
    },
    doEdit(id) {
      this.$router.push({path: "/user/add", query: {id: id}})
    },
    doDelete(id) {
      HTTPAUTH.delete("/api/v1/admin/user/" + id).then(() => {
        // this.$toasted.success("Data berhasil dihapus").goAway();
      }).catch(eres => {
        showErrorMessage(eres)
      })
    }
  },
};
</script>